/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ASP.NET 8 Web API for RIGHTIO Booking System - DEVELOPMENT
 * This is the API for the RIGHTIO Booking System, it is used to provide the booking system with data and to update the booking system with data.
 * OpenAPI spec version: v1
 */
import type {
  RightioWBSAPIModelsPaymentMethodId,
  RightioWBSAPIModelsPaymentMethodOutput,
  RightioWBSAPIModelsSetupIntentInput,
  RightioWBSAPIModelsSetupIntentOutput
} from '../../model';

import { customInstance } from '../../../../../services/DatabaseAccess/index';
import type { BodyType } from '../../../../../services/DatabaseAccess/index';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Retrieves the Square location ID required for payment processing and Web Payments SDK initialization. The location ID identifies the merchant location for transaction processing.
 * @summary Get Square Location ID
 */
export const paymentsSquareGetLocationId = (
    mode: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<string>(
      {url: `/api/payments/Square/location-id/${mode}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves the Square application ID required for Web Payments SDK authentication and initialization. The application ID establishes secure connectivity with Square's payment services.
 * @summary Get Square Application ID
 */
export const paymentsSquareGetApplicationId = (
    mode: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<string>(
      {url: `/api/payments/Square/application-id/${mode}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves the Square access token required for API authorization and payment processing. ⚠️ Security sensitive endpoint - ensure proper access controls.
 * @summary Get Square Access Token
 */
export const paymentsSquareGetAccessToken = (
    mode: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<string>(
      {url: `/api/payments/Square/access-token/${mode}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves the Stripe public key required for frontend Stripe.js initialization and client-side payment processing. The key is environment-specific and safe for client exposure.
 * @summary Get Stripe Public Key
 */
export const paymentsStripeGetPublicKey = (
    mode: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<string>(
      {url: `/api/payments/Stripe/public-key/${mode}`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a Stripe setup intent for collecting payment method details without immediate charge. Used for service agreements and future payment authorization with off-session capability.
 * @summary Create Stripe Setup Intent
 */
export const stripeCreateSetupIntent = (
    rightioWBSAPIModelsSetupIntentInput: BodyType<RightioWBSAPIModelsSetupIntentInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSetupIntentOutput>(
      {url: `/api/payments/Stripe/create-setup-intent`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSetupIntentInput
    },
      options);
    }
  /**
 * Retrieves detailed information about a Stripe payment method including card details, billing information, and capabilities. Used for displaying saved payment methods and processing off-session payments.
 * @summary Get Stripe Payment Method
 */
export const paymentsStripeGetPaymentMethod = (
    rightioWBSAPIModelsPaymentMethodId: BodyType<RightioWBSAPIModelsPaymentMethodId>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPaymentMethodOutput>(
      {url: `/api/payments/Stripe/get-payment-method`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPaymentMethodId
    },
      options);
    }
  export type PaymentsSquareGetLocationIdResult = NonNullable<Awaited<ReturnType<typeof paymentsSquareGetLocationId>>>
export type PaymentsSquareGetApplicationIdResult = NonNullable<Awaited<ReturnType<typeof paymentsSquareGetApplicationId>>>
export type PaymentsSquareGetAccessTokenResult = NonNullable<Awaited<ReturnType<typeof paymentsSquareGetAccessToken>>>
export type PaymentsStripeGetPublicKeyResult = NonNullable<Awaited<ReturnType<typeof paymentsStripeGetPublicKey>>>
export type StripeCreateSetupIntentResult = NonNullable<Awaited<ReturnType<typeof stripeCreateSetupIntent>>>
export type PaymentsStripeGetPaymentMethodResult = NonNullable<Awaited<ReturnType<typeof paymentsStripeGetPaymentMethod>>>
